import { Pipe, PipeTransform } from '@angular/core';
import { VehicleLocation } from '../models/domain/VehicleLocation';



@Pipe({ name: 'fullAddress' })
export class FullAddressPipe implements PipeTransform {


    public transform(location: VehicleLocation): string {
        let address = '';
        if (location) {
            address = this.appendToAddress(address, location.Cr);
            address = this.appendToAddress(address, location.Br);

            if (location.St && location.St !== location.Br) {
                address = this.appendToAddress(address, location.St);
            }

            address = this.appendToAddress(address, location.Hs);
            
            if (!location.Hs && !location.St && !location.Br) {
                address = this.appendToAddress(address, location.Ct);
                address = this.appendToAddress(address, location.Ds);
            }

            address = this.appendToAddress(address, location.Location);
            address = this.appendToAddress(address, location.Rd);
        }
        return address;
    }

    private appendToAddress(address: string, addressPart: string): string {
        if (addressPart) {
            address += (address ? ', ' : '') + addressPart;
        }

        return address;
    }
}
